import type { Agent } from '@studio/models/agent';
import type { Device } from '@studio/models/device';

const EMBEDDED_DEVICE_SUFFIX = '0001';
const AGENT_ID_PREFIX_LENGTH = 28;

/**
 * Builds the deterministic device identity used by an embedded camera's shadow record.
 *
 * Per rule: think-in-systems (ai.knowledge/global) — share identity generation and recognition.
 */
export const toEmbeddedShadowDeviceId = (agentId: Agent['id']): Device['id'] =>
  `${agentId.slice(0, AGENT_ID_PREFIX_LENGTH)}${EMBEDDED_DEVICE_SUFFIX}` as Device['id'];

/** Whether a device id is the deterministic embedded shadow id for an agent. */
export const isEmbeddedShadowDeviceId = (
  deviceId: Device['id'] | string,
  agentId: Agent['id'] | string
): boolean =>
  agentId.length >= AGENT_ID_PREFIX_LENGTH &&
  deviceId === toEmbeddedShadowDeviceId(agentId as Agent['id']);
